class DataCollectionInterfaces {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = basePath;

  }

  async getRowsHTML(pageId, collectionId, filterId, skip, limit) {

    const path = `${this.basePath}/pages/:pageId/data-collection-rows-html/public`;

    const body = {
      collectionId,
      filterId,
      paginationOptions: { skip, limit }
    };

    return this.apiClient.post(path, { pageId }, {}, body);

  }

}

export default DataCollectionInterfaces;
